import queryString from 'query-string'

import { generateID, getQueryParamsFromHash } from '@domain-group/javascript-utils'

const generateRedirectUrlWithCacheKey = () => {
  const [path] = window.location.hash.split('?')
  const stringifiedQuery = queryString.stringify({ ...getQueryParamsFromHash(), cacheKey: generateID() })

  return encodeURIComponent(`${path}?${stringifiedQuery}`)
}

export default generateRedirectUrlWithCacheKey
